import { CurrencyPipe } from "@angular/common";
import { Component, OnInit, Input } from "@angular/core";
import { Cart } from "../../../../cart/cart";
import { RentalRequestItem } from "../../models/rental-request-item.model";
import { RentalRequest } from "../../models/rental-request.model";
import { FulfillmentRequest } from "../../../fulfillments/models/fulfillment-request.model";

@Component({
  selector: "common-rental-details-card",
  templateUrl: "./rental-details-card.component.html",
  providers: [CurrencyPipe],
})
export class RentalDetailsCardComponent implements OnInit {
  @Input() rental: RentalRequest;
  @Input() fulfillment: FulfillmentRequest;
  @Input() cart: Cart;
  firstItem: RentalRequestItem;

  constructor() {}

  ngOnInit(): void {
    this.firstItem = this.rental.items[0];

    const { monthlySummary } = this.rental;
    if (!monthlySummary.length) {
      return;
    }
  }
}
